import ru from "./ru.json";
import en from "./en.json";

export type TLanguage = { [key: string]: string | TLanguage };

interface II18n {
	en: TLanguage;
	ru: TLanguage;
}

export const i18n: II18n = { en, ru };
